import { render } from "./CreateAccountForm.vue?vue&type=template&id=28fac8cb&scoped=true"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js"

import "./CreateAccountForm.vue?vue&type=style&index=0&id=28fac8cb&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fac8cb"]])

export default __exports__